import { render, staticRenderFns } from "./filter-identifier.vue?vue&type=template&id=34d2fddd"
import script from "./filter-identifier.vue?vue&type=script&lang=js"
export * from "./filter-identifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports